import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { languageSupport, languageService } from '@unpispas/upp-base';
import { viewService } from '@unpispas/upp-base';

import { TicketView } from '@unpispas/upp-data';

import { UppWdgtModule } from '@unpispas/upp-wdgt';

@Component({
    selector: 'upp-modal-cardpay',
    standalone: true,
    imports: [ CommonModule, IonicModule, UppWdgtModule ],
    templateUrl:'./upp-card-modal.html',
    styleUrls: [
        './upp-card-modal.scss'
    ]
})
export class UppCardPayModalComponent extends languageSupport {
    @Input() tickets: Array <TicketView> = [];
    @Output() OnAccept = new EventEmitter<void>();
    @Output() OnClose = new EventEmitter<void>();

    constructor(private lang: languageService, public view: viewService) {
        super(lang, null);
    }

    /********************************/
    /* DISPLAY OPTIONS              */
    /********************************/

    price(value: number): string{
        const _price: number = (Math.round(value * 100)/100);
        const _parts = Math.abs(_price).toString().split('.');

        const _int = _parts[0]
        const _dec = (_parts.length > 1) ? (_parts[1] + '0').slice(0, 2) : "00";

        return _int + ',' + _dec;
    }

    get AmountToPay(): number {
        let _totalprice = 0;

        for(const _ticket of this.tickets){
            _totalprice += Number(_ticket.due ?? _ticket.price ?? 0);
        }

        return _totalprice;
    }

    /***********************************/
    /* EVENT HANDLERS                  */
    /***********************************/

    OnAcceptClick() {
        (document.activeElement as HTMLElement)?.blur();
        this.OnAccept.emit();
    }

    OnCloseClick() {
        (document.activeElement as HTMLElement)?.blur();
        this.OnClose.emit();
    }
}
